import Swiper from 'swiper';
// import 'remodal';

// クリック表示
let myTarget = document.querySelectorAll('.detail');
let myTargetA = document.querySelectorAll('.ico');
let myTargetB = document.querySelectorAll('.detail a');
for (let i = 0; i < myTarget.length; i++) {
	myTarget[i].addEventListener('click', () => {
		myTarget[i].classList.toggle('opa1');
		myTarget[i].nextElementSibling.classList.toggle('close');
	});
}
for (let i = 0; i < myTargetA.length; i++) {
	myTargetA[i].addEventListener('click', () => {
		myTargetA[i].classList.toggle('close');
		myTargetA[i].previousElementSibling.classList.toggle('opa1');
	});
}
for (let i = 0; i < myTargetB.length; i++) {
	myTargetB[i].addEventListener('click', (e) => {
		e.stopPropagation();
	});
}

// fader
let slide = document.querySelectorAll('.fader');
for (let i = 0; i < slide.length; i++) {
	const swiper = document.querySelectorAll('.swiper-container')[i];
	new Swiper(swiper, {
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		loop: true,
		// watchOverflow: true, // loopと併用不可
		speed: 800,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		// hashNavigation: {
		//   replaceState: true,
		// },
		// scrollbar: {
		// 	el: document.querySelectorAll('.swiper-scrollbar')[i],
		// 	hide: false,
		// 	draggable: false,
		// },
		// pagination: {
		//   el: document.querySelectorAll('.swiper-pagination')[i],
		//   type: 'bullets',
		//   // type: 'progressbar',
		//   // type: 'fraction',
		//   clickable: true,
		// },
		// navigation: {
		//   nextEl: document.querySelectorAll('.swiper-button-next')[i],
		//   prevEl: document.querySelectorAll('.swiper-button-prev')[i],
		// },
	});
}

window.addEventListener('load', () => {
	/////// オープニングアニメーション ///////
	var targetObj = document.querySelector('.phase3');

	// スクロールイベント
	function noScroll(event) {
		event.preventDefault();
	}
	// PCスクロール禁止
	document.addEventListener('wheel', noScroll, {
		passive: false,
	});
	// SPスクロール禁止
	document.addEventListener('touchmove', noScroll, {
		passive: false,
	});
	// animationが始動したら
	// targetObj.addEventListener('animationstart', function () {
	// 	setTimeout(() => {
	// 		document.querySelector('.phase2').classList.add('end');
	// 	}, 600);
	// });
	// animationが終了したら
	targetObj.addEventListener('animationend', function () {
		// PCスクロール解放
		document.removeEventListener('wheel', noScroll, {
			passive: false,
		});
		// SPスクロール解放
		document.removeEventListener('touchmove', noScroll, {
			passive: false,
		});

		document.querySelector('.opening').classList.add('hidden');

		// キービジュアルアニメーション発火
		let myTarget = document.querySelectorAll('.kv h1 svg');
		for (let i = 0; i < myTarget.length; i++) {
			myTarget[i].classList.add('active');
		}

		setTimeout(() => {
			// オープニング消す
			document.querySelector('.opening').style.display = 'none';

			// document.querySelector('.kv h1 svg').classList.add('active');
			// document.querySelector('.keyvisual__ttl').classList.add('active');
		}, 1000);
	});

	// スクロールアニメーション
	funcAnim();

	window.addEventListener('scroll', () => {
		let value = window.pageYOffset || document.documentElement.scrollTop;

		// キービジュアル通過でヘッダー表示
		let topbar = document.querySelector('.kv__area').clientHeight;
		let myTarget = document.querySelector('.side__logo');
		let mainVisual = document.querySelector('.kv__visual');

		if (value > topbar) {
			myTarget.classList.add('active');
			mainVisual.classList.add('active');
		} else {
			myTarget.classList.remove('active');
			mainVisual.classList.remove('active');
		}

		// footerでヘッダー非表示
		let btmbar = document.querySelector('footer');
		let rect = btmbar.getBoundingClientRect();
		let posiTop = rect.top + value; // ターゲットがブラウザTOPに来たら
		// let posiMid = posiTop - window.innerHeight / 2; // ターゲットがブラウザMIDに来たら
		let posiBtm = posiTop - window.innerHeight; // ターゲットがブラウザBOTOMに来たら
		let myHeight = btmbar.clientHeight - 0;
		let position_bottom = posiTop + myHeight; // ターゲットが下からスクロールしたときに見える位置

		// ターゲットが来た時ときの動き
		if (value > posiBtm && value < position_bottom) {
			myTarget.classList.remove('active');
		} else {
			// それ以外の動き
			// document.querySelector('header').classList.add('active');
		}

		// class area通過でmainにclass追加
		let myMain = document.querySelectorAll('.area');
		for (let i = 0; i < myMain.length; i++) {
			let rect = myMain[i].getBoundingClientRect();
			let posiTop = rect.top + value + 0; // ターゲットがブラウザTOPに来たら
			// let posiMid = posiTop - window.innerHeight / 2; // ターゲットがブラウザMIDに来たら
			let posiBtm = posiTop - window.innerHeight; // ターゲットがブラウザBOTOMに来たら
			let myHeight = myMain[i].clientHeight - 0;
			let position_bottom = posiTop + myHeight; // ターゲットが下からスクロールしたときに見える位

			if (value > posiBtm && value < position_bottom) {
				// ターゲットが来た時ときの動き
				document.querySelector('.bg' + [i + 1]).style.zIndex = '2';
				setTimeout(() => {
					document.querySelector('.bg' + [i + 1]).classList.add('action' + [i + 1]);
				}, 1000);
			} else {
				// それ以外の動き
				document.querySelector('.bg' + [i + 1]).classList.remove('action' + [i + 1]);
				setTimeout(() => {
					document.querySelector('.bg' + [i + 1]).style.zIndex = '0';
				}, 1000);
			}
		}
	});
});

// スクロールアニメーション
const funcAnim = () => {
	const progressItems = document.querySelectorAll('.anim');
	const observeAction = (entries) => {
		entries.forEach((entry) => {
			// let i = entry.target;
			if (entry.isIntersecting) {
				// console.log('きた');
				entry.target.classList.add('active');
			}
			// else {
			// 	// console.log('こない');
			// 	entry.target.classList.remove('active');
			// }
		});
	};

	const options = {
		root: null,
		rootMargin: '0px 0px -10% 0px',
		threshold: 0,
	};

	const obsever = new IntersectionObserver(observeAction, options);

	progressItems.forEach((target) => {
		obsever.observe(target);
	});
};
